import type { VoiceSession } from "../../core/types";
import storageService from "./storageService";
import { getErrorStatus } from "../utils/getErrorStatus";

export type VoiceSessionResult =
  | { success: true; voiceSession: VoiceSession }
  | { success: false; status: number | undefined };

export const createVoiceSession = async (
  apiUrl: string,
  token: string,
  widgetId: string,
  messageThreadId: string,
  signal: AbortSignal,
): Promise<VoiceSessionResult> => {
  const url = new URL(`${apiUrl}/voice_sessions/auth`);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message_thread_id: messageThreadId,
        uuid: storageService.getContact(widgetId, "uuid"),
      }),
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const voiceSession = (await response.json()) as VoiceSession;
    return { success: true, voiceSession };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};
